import $ from 'jquery'
import { unloading, makePulse, shaker } from './utilities'

var mobileForm = document.getElementById('msisdn_form')
var mobile = document.getElementById('mobile')
var pin = document.getElementById('pin')
var confirmPin = document.getElementById('confirmPin')
var pinForm = document.getElementById('pin_form')
var inValidPhone = document.getElementById('inValidPhone')

export function verifySuccess(res) {
  unloading()
  $(mobileForm).slideUp()
  $(pinForm).slideDown()
  pin.addEventListener('keyup', makePulse(confirmPin))
}
export function verifyError(res) {
  console.log('connection error: ', res)
  unloading()
  $(inValidPhone).slideDown()// show invalid phone div
  shaker(mobileForm, mobile)// shake these tow
}
